module.exports = __webpack_public_path__ + "assets/img/8_1725.365a982c.jpg";